// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"41e7e60b","455":"f8958afc","886":"8ed02e97"}[chunkId] + ".chunk.js";
};